<script setup lang="ts">
import { AvatarImage, type AvatarImageProps } from 'radix-vue'
import type {HTMLAttributes} from "vue";
import {cn} from "@/shared/lib/utils.ts";

const props = defineProps<AvatarImageProps & { class?: HTMLAttributes['class'] }>()
</script>

<template>
  <AvatarImage v-bind="props" :class="cn('h-full w-full object-cover', props.class)" />
</template>
